import { FC } from 'react';
import classNames from 'classnames';
import { AddAvatar } from 'tedooo-web-design-system/ui';
import Lottie from 'react-lottie';
import { Camera, User } from 'tedooo-web-design-system/icons';

import Animation from 'lotties/add-avatar-lottie.json';
import { Avatar } from 'components/avatar/Avatar';

export interface IProfileAvatar {
  shouldDisplayLottie: boolean;
  isLoggedInUser: boolean;
  avatar: string;
  isLoading: boolean;
  isOnline: boolean;
  onAvatarChange(file: File): void;
}

const ProfileAvatar: FC<IProfileAvatar> = ({
  isLoggedInUser,
  isOnline,
  isLoading,
  avatar,
  onAvatarChange,
  shouldDisplayLottie,
}) => {
  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: Animation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  if (isLoggedInUser) {
    const badge = shouldDisplayLottie ? (
      <Lottie options={lottieOptions} height="140%" isClickToPauseDisabled />
    ) : (
      <Camera className="camera-icon" />
    );

    return (
      <AddAvatar
        id="profile-header"
        onAvatarChange={onAvatarChange}
        size={90}
        avatar={avatar}
        placeholder={<User />}
        isLoading={isLoading}
        badge={badge}
      />
    );
  }

  return (
    <Avatar
      src={avatar}
      size={86}
      icon={<div className={classNames('connect-status', { online: isOnline })} />}
    />
  );
};

export default ProfileAvatar;
